import { UPDATE_NOTIFICATIONS_DATA } from './types';


export function notificationsReducer(state, action) {

    const { payload, type } = action


    switch (type) {

        case UPDATE_NOTIFICATIONS_DATA:
            return {
                ...state,
                notificationsData: payload
            }
        default:
            break;
    }

} 